import React, { useRef } from "react"

import styles from './home.module.css';

import ScrollService from '../../../services/scroll_event/scroll_event'

import Header from "../../header/header";
import MotionScreen from "../motion_screen/motion_screen";
import DivisionSection from "../division_section/division_section";
import MissionVision from "../mission_vision/mission_vision";
import Footer from "../../footer/footer";

const Home = () => {
  const scrollService = new ScrollService();
  const topPoint = useRef(null);
  const introPoint = useRef(null);

  const onHomeClick = () => {
    scrollService.onMissionClick(introPoint)
  };
  const onLogoClick = () => {
    scrollService.onMissionClick(topPoint)
  };

  return (
    <section className={styles.container}>
      <Header
        onHomeClick={onHomeClick}
        onLogoClick={onLogoClick}
      />
      <MotionScreen ref={topPoint} />
      <DivisionSection />
      <MissionVision ref={introPoint} />
      <Footer />
    </section>
  )
}

export default React.memo(Home);